// Utilitário para gerenciar localStorage de forma consistente
export const storage = {
  // Filtros da listagem de Individual
  getIndividualFilters: () => {
    try {
      const filters = localStorage.getItem('individual_filters');
      return filters ? JSON.parse(filters) : {
        txtNameSocialId: '',
        txtEmail: '',
        txtMobile: ''
      };
    } catch {
      return {
        txtNameSocialId: '',
        txtEmail: '',
        txtMobile: ''
      };
    }
  },

  setIndividualFilters: (filters: {
    txtNameSocialId: string;
    txtEmail: string;
    txtMobile: string;
  }) => {
    try {
      localStorage.setItem('individual_filters', JSON.stringify(filters));
    } catch (error) {
      console.warn('Failed to save filters:', error);
    }
  },

  // Ordenação e paginação da listagem
  getIndividualListState: () => {
    try {
      const state = localStorage.getItem('individual_list_state');
      return state ? JSON.parse(state) : {
        page: 0,
        pageSize: 100,
        field: 'id',
        order: 'DESC'
      };
    } catch {
      return {
        page: 0,
        pageSize: 100,
        field: 'id',
        order: 'DESC'
      };
    }
  },

  setIndividualListState: (state: {
    page: number;
    pageSize: number;
    field: string;
    order: 'ASC' | 'DESC';
  }) => {
    try {
      localStorage.setItem('individual_list_state', JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save list state:', error);
    }
  },

  // Limpar dados ao fazer logout
  clearAll: () => {
    try {
      localStorage.removeItem('individual_filters');
      localStorage.removeItem('individual_list_state');
      localStorage.removeItem('authToken');
    } catch (error) {
      console.warn('Failed to clear storage:', error);
    }
  }
};
